// extracted by mini-css-extract-plugin
export default {"wrapper":"payment-buttons_wrapper__OVroL"};